import { createApi } from '@reduxjs/toolkit/query/react';
import { OtpUrl } from '../../api/endpoints';
import {baseQueryWithReauth,} from "../../api/baseQuery";

export const requestOtpApi= createApi({
  reducerPath: 'requestOtpApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    postOtp: builder.mutation({
      query: (initialValues) => ({
        url: OtpUrl,
        method: 'POST',
        body: initialValues,
      }),
    }),
  }),
});

export const { usePostOtpMutation } = requestOtpApi;
